import { withMainControls } from '@eventbrite/eds-structure';
import { getCanonicalSearchUrl } from '@eventbrite/redux-destination';
import * as analytics from '@eventbrite/site-analytics';
import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useMount } from 'react-use';
import { compose } from 'redux';
import {
    handleApplyFilter as handleApplyFilterAction,
    handleApplyFilterSimple as handleApplyFilterSimpleAction,
    searchEventSuggestions as searchEventSuggestionsAction,
} from '../../../../redux/actions/search';
import { SearchPivotSuggestionsShape } from '../../../../types/index';
import { addSearchIdToGaAction } from '../../utils/analytics';
import { LowResults, NoResults } from './components/EmptyState';
import {
    EventSuggestions,
    FilterSuggestions,
    TagSuggestions,
} from './components/Suggestions';
import { GA_SEARCH_REDIRECTION_CATEGORY } from './constants';
import {
    getEventSuggestions,
    getParsedSuggestedFilters,
    getRandomizedSuggestedTags,
    getTrendingSearchData,
    hasEventResults,
    isNextDisabled,
} from './selectors';

interface SearchPivotSuggestionsProps {
    currentPlace?: string;
    hasEventResults?: boolean;
    isOnlineSearch?: boolean;
    isOrganizationsSearch?: number;
    trackGAEvent?: Function;
}

const SearchPivotSuggestions = (props: SearchPivotSuggestionsProps) => {
    const { trackGAEvent } = props;

    //TODO: trigger this on scroll into view as opposed to on mount
    useMount(() => {
        trackGAEvent?.({
            action: 'EndResultsSectionShown',
            nonInteraction: true,
        });
    });

    return (
        <>
            <section className="search-result-pivots__empty-state">
                {props.hasEventResults ? (
                    <LowResults containerClassname="eds-l-pad-hor-6" />
                ) : (
                    <NoResults
                        containerClassname="eds-l-pad-hor-6"
                        isOrganizationsSearch={props.isOrganizationsSearch}
                        isOnlineSearch={props.isOnlineSearch}
                        currentPlace={props.currentPlace}
                    />
                )}
            </section>
            <EventSuggestions {...props} />
            <TagSuggestions {...props} />
            <FilterSuggestions {...props} />
        </>
    );
};

const _mapStateToProps = (state: SearchPivotSuggestionsShape) => ({
    isLoading: state.pagination.loading,
    isNextDisabled: isNextDisabled(state),
    hasEventResults: hasEventResults(state),
    featureFlags: state.app.featureFlags,
    suggestionsLoading: state.suggestions.loading,
    eventSuggestions: getEventSuggestions(state),
    suggestedFilters: getParsedSuggestedFilters(state),
    suggestedTags: getRandomizedSuggestedTags(state),
    isAuthenticated: state.auth.isAuthenticated,
    shareOptions: state.share?.options,
    allEventsUrl: getCanonicalSearchUrl({ slug: state.location.slug }),
    trackGAEvent: (action: any) =>
        analytics.trackEventFromState(
            state,
            addSearchIdToGaAction(
                { ...action, category: GA_SEARCH_REDIRECTION_CATEGORY },
                state,
            ),
        ),
    trackGAEventOnPageUnload: (action: any) =>
        analytics.trackEventFromStateOnPageUnload(
            state,
            addSearchIdToGaAction(
                {
                    ...action,
                    category: GA_SEARCH_REDIRECTION_CATEGORY,
                },
                state,
            ),
        ),
    trendingSearchData: getTrendingSearchData(
        state.location,
        state.app.domain,
        state.shouldShowTrendingSearchPageLink,
    ),
    isOnlineSearch: state.location.slug == 'online',
    currentPlace: state.location.currentPlace,
    bbox: state.search.eventSearch.bbox,
    isOrganizationsSearch: state.search.eventSearch.organizationsOr.length,
});

const _mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
    handleApplyFilter: (...args: [$FixMe]) =>
        dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleApplyFilterSimple: (...args: [$FixMe]) =>
        dispatch(handleApplyFilterSimpleAction(ownProps.history, ...args)),
    searchEventSuggestionsAction: (...args: any) =>
        dispatch(searchEventSuggestionsAction(...args)),
});

const enhance = compose(
    withMainControls,
    withRouter,
    connect(_mapStateToProps, _mapDispatchToProps),
);

export default enhance(SearchPivotSuggestions);
